"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _urls = _interopRequireDefault(require("./constants/urls"));
var _useIntersect = require("./hooks/useIntersect");
var _usePrevious = require("./hooks/usePrevious");
var _excluded = ["isLazy", "src", "intersectionMargin"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function Image(_ref) {
  var _ref$isLazy = _ref.isLazy,
    isLazy = _ref$isLazy === void 0 ? false : _ref$isLazy,
    src = _ref.src,
    intersectionMargin = _ref.intersectionMargin,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var img = (0, _react.useRef)();
  var isIntersecting = (0, _useIntersect.useIntersect)(img, intersectionMargin);
  var _useState = (0, _react.useState)(isLazy ? null : src),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    imgSrc = _useState2[0],
    setSource = _useState2[1];
  var prevSrc = (0, _usePrevious.usePrevious)(src);
  var hasUpdatedSrc = src !== prevSrc && (isLazy && prevSrc && src || !isLazy);
  var hasNotErrored = imgSrc !== _urls["default"].images.deadImage;
  var onError = hasNotErrored ? function () {
    return setSource(_urls["default"].images.deadImage);
  } : null;
  (0, _react.useEffect)(function () {
    if (!isLazy && !hasUpdatedSrc) {
      return;
    }
    if (isIntersecting && hasNotErrored || hasUpdatedSrc) {
      // Set image source
      setSource(src);
    }
  }, [imgSrc, src, isLazy, isIntersecting, hasUpdatedSrc, hasNotErrored]);
  return /*#__PURE__*/_react["default"].createElement("img", (0, _extends2["default"])({
    ref: img,
    src: imgSrc || null,
    onError: onError
  }, props, {
    alt: hasNotErrored ? props.alt : "Error placeholder for ".concat(props.alt)
  }));
}
Image.displayName = 'Image';
var _default = exports["default"] = Image;